const errorMessage = 'This field is required';
const isRequiredAndSelected = previewEntry => {
  const {
    value,
    required
  } = previewEntry;
  if (required && !value) {
    return errorMessage;
  }
};
export default [{
  validation: isRequiredAndSelected,
  type: 'required'
}];